import { render, staticRenderFns } from "./MentalAiTool.vue?vue&type=template&id=3667568e&scoped=true"
import script from "./MentalAiTool.vue?vue&type=script&lang=js"
export * from "./MentalAiTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667568e",
  null
  
)

export default component.exports